'use client';

import { useCookieConsentListener } from '@hooks/use-cookie-consent-listener';
import type { ReactNode } from 'react';

import { useOnIdTokenChangedObserver } from '../auth-helpers';
import { AmplitudeExperimentsProvider } from '../feature-flag';

export function RootLayoutProvider({ children }: { children: ReactNode }) {
  useCookieConsentListener();
  useOnIdTokenChangedObserver();

  return (
    <AmplitudeExperimentsProvider userProfileDetails={null}>
      {children}
    </AmplitudeExperimentsProvider>
  );
}
